import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface User {
  code: string;
  name: string;
  mobileNumber: string;
  password: string;
  api_token: string;
}

export interface UserAuthInfo {
  errors: unknown;
  user: User;
  isAuthenticated: boolean;
}

@Module
export default class AuthModule extends VuexModule implements UserAuthInfo {
  errors = null;
  user = {} as User;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get currentUser(): User {
    return this.user;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */
  get isUserAuthenticated(): boolean {
    return this.isAuthenticated;
  }

  /**
   * Get authentification errors
   * @returns array
   */
  get getErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SET_AUTH](user) {
    this.isAuthenticated = true;
    this.user = user;
    this.errors = null;
    //console.log(user);
    JwtService.saveToken(user.api_token, user.refresh_token);
  }

  @Mutation
  [Mutations.SET_USER](user) {
    this.user = user;
  }

  @Mutation
  [Mutations.SET_PASSWORD](password) {
    this.user.password = password;
  }

  @Mutation
  [Mutations.PURGE_AUTH]() {
    this.isAuthenticated = false;
    this.user = {} as User;
    this.errors = null;
    JwtService.destroyToken();
  }

  @Action
  [Actions.LOGIN](credentials) {
    return ApiService.post("authentication/login", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        if (response) {
          this.context.commit(
            Mutations.SET_ERROR,
            response.data?.error ??
              "ไม่สามารถดำเนินการได้ กรุณาติดต่อฝ่ายบริการลูกค้า"
          );
        } else {
          this.context.commit(Mutations.SET_ERROR, {
            message: "ไม่สามารถดำเนินการได้ กรุณาติดต่อฝ่ายบริการลูกค้า",
          });
        }
      });
  }

  @Action
  [Actions.LOGOUT]() {
    this.context.commit(Mutations.PURGE_AUTH);
  }

  @Action
  [Actions.REGISTER](credentials) {
    return ApiService.post("register", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.FORGOT_PASSWORD](payload) {
    return ApiService.post("forgot_password", payload)
      .then(() => {
        this.context.commit(Mutations.SET_ERROR, {});
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  /*   @Action
  [Actions.VERIFY_AUTH](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.post("authentication/verify_token", payload)
        .then(({ data }) => {
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          this.context.commit(Mutations.PURGE_AUTH);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  } */

  @Action
  [Actions.VERIFY_AUTH](payload) {
    if (JwtService.getToken()) {
      //ApiService.setHeader();
      ApiService.post("authentication/refresh_token", payload)
        .then(({ data }) => {
          //JwtService.saveToken(data.api_token, data.refresh_token);
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(({ response }) => {
          //this.context.commit(Mutations.SET_ERROR, response.data.errors);
          this.context.commit(Mutations.PURGE_AUTH);
          //console.log("perge auth");
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
      //console.log("perge auth");
    }
  }
  @Action
  async [Actions.ASYNC_VERIFY_AUTH](payload) {
    //console.log("ASYNC_VERIFY_AUTH");
    if (JwtService.getToken()) {
      //ApiService.setHeader();
      ApiService.post("authentication/refresh_token", payload)
        .then(({ data }) => {
          //JwtService.saveToken(data.api_token, data.refresh_token);
          this.context.commit(Mutations.SET_AUTH, data);
        })
        .catch(() => {
          //this.context.commit(Mutations.SET_ERROR, response.data.errors);
          this.context.commit(Mutations.PURGE_AUTH);
          //console.log("perge auth");
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
      //console.log("perge auth");
    }
  }

  /*   @Action
  [Actions.SINGLE_AUTH](payload) {
    console.log("SINGLE_AUTH 1");
    ApiService.post("authentication/singleAuth", payload)
      .then(({ data }) => {
        //console.log(data);
        console.log("SINGLE_AUTH 2");
        this.context.commit(Mutations.SET_AUTH, data);
        console.log(this.isAuthenticated);
      })
      .catch(() => {
        this.context.commit(Mutations.PURGE_AUTH);
      });
  } */

  @Action
  async [Actions.SINGLE_AUTH](payload) {
    await ApiService.post("authentication/singleAuth", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUTH, data);
      })
      .catch(() => {
        this.context.commit(Mutations.PURGE_AUTH);
      });
  }
}
